import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import _ from 'lodash';
import Utils from "../../Utils/Utility";
import CONFIG_HELPER from './../../../ConfigHelper';
import Actions from "../../actions";
import MainStore from '../stores/main-store';
import ReactDragListView from 'react-drag-listview';
import AddChargeOptions from "../custom-charges/add-charge-options";
import CustomChargeStore from "../stores/custom-charge-store";
import {v4 as uuidv4} from 'uuid';


const Default_Round_Up_Name = "Round Up & Donate";
const Default_Round_Up_Desc = "Yes, I want to round up";
const Default_Fixed_Charge_Desc = "(Fixed charges are added as line item charge)";
const Default_Round_Up_Charge_Desc = "(For Charity Support)";
const Default_Optional_Charge_Desc = "(Optional charges are added as line item charge)";
const FIXED_CHARGE = "fixed";
const OPTIONAL_CHARGE = "optional";
const ROUND_UP_CHARGE = "roundUp";

const DELIVERY = "Delivery";
const PICKUP = "PickUp";
const CURBSIDEPICKUP = "CurbsidePickUp";
const DINEIN = "DineIn";

export default class AddCharge extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            fields: {
                tag:'',
                name: '',
                description: '',
                status: 'inactive',
                chargeType: FIXED_CHARGE,
                orderType:'',
                taxable: 'false',
                cOptionName: '',
                cOptionDescription: '',
                cOptionInfoLink: '',
                cOptionLogoUrl:  '',
                percentageFee: '',
                fixedFee: ''
            },
            errors: {},
            chargeDetail:{},
            isLoaded: true,
            chargeOptions: [],
            showTaxableField: false,
            showChargeOptionsView:false,
            showChargeOptionsValueView:false,
            selectedChargeType: '',
            chargeTypeMsg:'',
            labelOptions:'',
            defaultIdx:'',
            orderTypes:[]
        };

        this._bind(
            'addChargeOptionsAction',
            'handleChange',
            'loadChargeDetail'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {

        let self = this;

        // when load the main class get all the data and reload
        self.loadChargeDetail();

    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation,
            chargeDetail: this.props.chargeDetail
        });
    }

    componentWillReceiveProps(nextProps) {

        let self = this;

        if (nextProps !== null) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                    chargeDetail: nextProps.chargeDetail
                },
                () => {
                    self.loadChargeDetail();
                });
        }
    }

    loadChargeDetail(){

        let self = this;

        let chargeDetail = this.state.chargeDetail;

        if (chargeDetail && !Utils.isEmptyObj(chargeDetail)) {

            let name = chargeDetail.name;
            let tag = chargeDetail.tag;

            let chargeType = Utils.getChargeTypeKey(chargeDetail.type);

            let chargeOptions = self.loadChargeOptions(chargeDetail.typeDetails.values);
            let orderTypesArray = chargeDetail.orderTypes;


            let defaultIdx = chargeDetail.typeDetails.defaultIdx;

            if (defaultIdx == undefined || defaultIdx == null){
                defaultIdx = '';
            }

            self.setState({
                fields: {
                    name: name,
                    tag: tag,
                    description: chargeDetail.desc,
                    status: chargeDetail.active == true ? 'active' : 'inactive',
                    chargeType: chargeType,
                    orderType: '',
                    taxable: chargeDetail.taxable == true ? 'true' : 'false',
                    cOptionName: chargeDetail.typeDetails.name || '',
                    cOptionDescription: chargeDetail.typeDetails.desc || '',
                    cOptionInfoLink: chargeDetail.typeDetails.infoLink || '',
                    cOptionLogoUrl: chargeDetail.typeDetails.logoURL || '',
                    viewType: chargeDetail.typeDetails.viewType || "Row"
                },
                isLoaded: true,
                defaultIdx:defaultIdx,
                orderTypes: orderTypesArray,
            });

            self.updateStatesBasedOnChargeType(chargeType, chargeOptions);


        } else {
            this.setState({
                fields: {
                    status: 'inactive',
                    chargeType: 'fixed',
                    orderType: '',
                    taxable: 'false',
                    viewType: "Row"
                },
                chargeTypeMsg:Default_Fixed_Charge_Desc,
                isLoaded: true,
                showTaxableField:true,
                showChargeOptionsView:false,
                showChargeOptionsValueView:false,
                selectedChargeType:"fixed",
                chargeOptions: [],
                labelOptions:'',
                defaultIdx:''
            });
        }
    }

    loadChargeOptions(chargeOptionsValues){

        let optionsArray = [];

        if (chargeOptionsValues && chargeOptionsValues.length > 0) {
            chargeOptionsValues.map((chargeOpt, i) => {

                let optionJSON = {};
                optionJSON["idx"] = chargeOpt.idx || i;
                optionJSON["name"] = chargeOpt.name;
                optionJSON["var"] = chargeOpt.var;
                optionJSON["fixed"] = chargeOpt.fixed;
                optionsArray.push(optionJSON);

            });
        }

        return optionsArray;

    }

    handleValidation(){

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        let self = this;

        let chargeDetail = this.state.chargeDetail;

        let chargeId = '';
        // Update the existing charge based on the charge id
        if (chargeDetail && !Utils.isEmptyObj(chargeDetail)) {
            // set the existing chargeId
            chargeId = chargeDetail.chargeId;
        }


        let orderTypes = this.state.orderTypes;
        if(orderTypes.length == 0){
            formIsValid = false;
            errors["orderType"] = "Cannot be empty";
        }

        if(!fields["chargeType"]){
            formIsValid = false;
            errors["chargeType"] = "Cannot be empty";
        }

        // add validation based on the charge type
        if(this.state.showTaxableField){
            if(!fields["taxable"]){
                formIsValid = false;
                errors["taxable"] = "Cannot be empty";
            }
        }

        if(!fields["status"]){
            formIsValid = false;
            errors["status"] = "Cannot be empty";
        }

        if(Utils.isEmpty(fields["tag"]) || Utils.isEmptyWithTrim(fields["tag"])){
            formIsValid = false;
            errors["tag"] = "Cannot be empty";
        }
        else {
          let chargeTag =  fields["tag"];

          // check the charge tag is exist or not
           let isTagExist = CustomChargeStore.checkChargeTagExist(chargeTag, chargeId);

           if(isTagExist){
               formIsValid = false;
               errors["tag"] = "Charge tag already exists.";
           }

        }


        if (!self.isChargeTypeRoundUp(fields["chargeType"])) {
            // check name for Fixed and Optional Charge type
            // Name not required for roundUp charge

            if(Utils.isEmpty(fields["name"]) || Utils.isEmptyWithTrim(fields["name"])){
                formIsValid = false;
                errors["name"] = "Cannot be empty";
            }
        }

        // check validation for fixed charge only
        if (self.isChargeTypeFixed(fields["chargeType"])){
            if (Utils.isEmpty(fields["percentageFee"])){
                fields["percentageFee"] = 0;
            }
            if (Utils.isEmpty(fields["fixedFee"])){
                fields["fixedFee"] = 0;
            }

            if(!fields["percentageFee"] && !fields["fixedFee"]){
                formIsValid = false;
                errors["percentageFee"] = "Cannot be empty";
                errors["fixedFee"] = "Cannot be empty";
            }

            if (fields["percentageFee"] == 0 && fields["fixedFee"] == 0){
                formIsValid = false;
                errors["errors"] = "Percentage Fee/Fixed Fee should be granter than 0";
            }
        }

        // add validation based on the charge type
        // it will check only for roundUp charge
        if (self.isChargeTypeRoundUp(fields["chargeType"])){

            // Check the round up charge is exist or not
                if (CustomChargeStore.isRoundUpExits(chargeId)){
                    formIsValid = false;
                    errors["chargeType"] = "Round Up charge is already configured.";
                }


            if(Utils.isEmpty(fields["cOptionName"]) || Utils.isEmptyWithTrim(fields["cOptionName"])){
                formIsValid = false;
                errors["cOptionName"] = "Cannot be empty";
            }
            if(!fields["cOptionDescription"]){
                formIsValid = false;
                errors["cOptionDescription"] = "Cannot be empty";
            }
            if(!fields["cOptionInfoLink"]){
                formIsValid = false;
                errors["cOptionInfoLink"] = "Cannot be empty";
            }
            if(!fields["cOptionLogoUrl"]){
                formIsValid = false;
                errors["cOptionLogoUrl"] = "Cannot be empty";
            }
        }

        if(self.isChargeTypeOptional(fields["chargeType"])){
            // check the validation of options value is not empty
            // if (this.state.showChargeOptionsValueView){
                let chargeOptions = this.state.chargeOptions;
                if (chargeOptions.length == 0){
                    formIsValid = false;
                    errors["errors"] = "Please add Charge Values.";
                }
            // }
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    updateStatesBasedOnChargeType(chargeType, chargeOptions){

        if (chargeOptions == undefined || chargeOptions == null || chargeOptions.length == 0){
            chargeOptions = [];
        }
        let self = this;

        if (self.isChargeTypeOptional(chargeType)){

            self.setState({
                showTaxableField:true,
                showChargeOptionsView:true,
                showChargeOptionsValueView:true,
                selectedChargeType:chargeType,
                chargeOptions: chargeOptions,
                chargeTypeMsg:Default_Optional_Charge_Desc,
                labelOptions:"Business/Organization"
            });
        }
        else if (self.isChargeTypeRoundUp(chargeType)){

            self.setState({
                showTaxableField:false,
                showChargeOptionsView:true,
                showChargeOptionsValueView:false,
                selectedChargeType:chargeType,
                chargeOptions: chargeOptions,
                chargeTypeMsg:Default_Round_Up_Charge_Desc,
                labelOptions:"Charity"
            });

        }else if (self.isChargeTypeFixed(chargeType)){

            let percentageFee = 0;
            let fixedFee = 0;

            if (chargeOptions.length > 0){

                let chargeObj = chargeOptions[0];
                percentageFee = chargeObj.var ? chargeObj.var : 0;
                fixedFee = chargeObj.fixed ? chargeObj.fixed : 0;
            }

            self.setState(prevState => ({
                fields: {
                    ...prevState.fields,   // copy all fields key-value pairs
                    percentageFee: percentageFee,
                    fixedFee: fixedFee      // set the real value
                },
                showTaxableField:true,
                showChargeOptionsView:false,
                showChargeOptionsValueView:false,
                selectedChargeType:chargeType,
                chargeOptions: chargeOptions,
                chargeTypeMsg:Default_Fixed_Charge_Desc,
                labelOptions:''
            }))

        }else {
            self.setState({
                showTaxableField:false,
                showChargeOptionsView:false,
                showChargeOptionsValueView:false,
                selectedChargeType:FIXED_CHARGE,
                chargeOptions: chargeOptions,
                chargeTypeMsg:'',
                labelOptions:''
            });
        }
    }

    handleChange(field, e){

        let errors = {};
        let self = this;
        this.setState({
            errors: errors
        });

        let fields = this.state.fields;
        var value = e.target.value;


        if(field == "tag"){
            let strWithOutSpecialChar = value.replace(/[^\w\s]/gi, "");
            value = strWithOutSpecialChar.toUpperCase();
        }


        if (field == "orderType") {
            // let value = e.target.value;
            let orderTypesArray = this.state.orderTypes;

            if (e.target.checked) {
                orderTypesArray.push(value);
            } else {
                let index = orderTypesArray.indexOf(value);
                if (index !== -1) {
                    orderTypesArray.splice(index, 1);
                }
            }
        }

        if (field == 'chargeType') {
            // let chargeType = e.target.value;

            // update the states value according to the selected Charge Type
            self.updateStatesBasedOnChargeType(value, null);
        }

        if (field == 'percentageFee') {
            // let percentageFeeValue = e.target.value;
            let validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(value)) {
                let error = "Var format is wrong. It must be a numerical value like 2 %";
                // alert(error);
                // console.log(error);
                let errors = {};
                errors["percentageFee"] = error;
                this.setState({errors: errors});
                return
            }
        }

        if (field == 'fixedFee') {
            // let fixedFeeValue = e.target.value;
            let validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(value)) {
                let error = "Var format is wrong. It must be a numerical value like $2.00";
                // alert(error);
                // console.log(error);
                let errors = {};
                errors["fixedFee"] = error;
                this.setState({errors: errors});
                return
            }
        }

        fields[field] = value;
        this.setState({fields});

    }

    getChargeOptionsJson() {

        let jsonArray = [];

        let chargeOptions = this.state.chargeOptions;

        if (chargeOptions && chargeOptions.length > 0) {

            chargeOptions.map((option, i) => {

                let optionJSON = {};
                // console.log(item.optionCategoryName);
                optionJSON["idx"] = i;
                optionJSON["name"] = option.name;
                optionJSON["var"] = _.round(option.var, 2);
                optionJSON["fixed"] = _.round(option.fixed, 2);

                jsonArray.push(optionJSON);

            });
        }

        return jsonArray
    }

    addChargeFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){

            let self = this;
            self.setState({
                isLoaded : false
            });
            let fields = self.state.fields;

            let status = false;
            if (fields["status"] == "active"){
               status = true;
            }

            let name = "";
            if(!Utils.isEmpty(fields["name"])){
                name = fields["name"];
            }

            let tag = "";
            if(!Utils.isEmpty(fields["tag"])){
                tag = fields["tag"];
            }

           let description = "";
           if(!Utils.isEmpty(fields["description"])){
               description = fields["description"];
           }

           // charge type = fixed, optional, round up
           let chargeType = fields["chargeType"];
           let chargeShortName = Utils.getChargeShortName(chargeType);

            let taxable = false;
            let chargeOptions = null;
            let cOptionName = "";
            let cOptionDescription = "";
            let cOptionInfoLink = "";
            let cOptionLogoUrl = "";
            let cOptionViewType =  "";
            // let cOptionCustomButton = false;

            // Fixed Charge
            if (self.isChargeTypeFixed(chargeType)){

                // if charge type fixed then check only following options
                if (!Utils.isEmpty(fields["taxable"]) && fields["taxable"] == 'true') {
                    taxable = true;
                }

                let percentageFee = 0;
                if (!Utils.isEmpty(fields["percentageFee"])) {
                    percentageFee = fields["percentageFee"];
                }

                let fixedFee = 0;
                if (!Utils.isEmpty(fields["fixedFee"])) {
                    fixedFee = fields["fixedFee"];
                }

                // set default chargeOptions value in the array
                this.state.chargeOptions = [{name: "", var: percentageFee, fixed: fixedFee}];

           }
           else if (self.isChargeTypeOptional(chargeType)){
                // Optional Charge

                // if charge type fixed then check only following options
                if(!Utils.isEmpty(fields["taxable"]) && fields["taxable"] == 'true'){
                    taxable = true;
                }

                if(!Utils.isEmpty(fields["cOptionName"])){
                    cOptionName = fields["cOptionName"];
                }

                if(!Utils.isEmpty(fields["cOptionDescription"])){
                    cOptionDescription = fields["cOptionDescription"];
                }

                if(!Utils.isEmpty(fields["cOptionInfoLink"])){
                    cOptionInfoLink = fields["cOptionInfoLink"];
                }
                if(!Utils.isEmpty(fields["cOptionLogoUrl"])){
                    cOptionLogoUrl = fields["cOptionLogoUrl"];
                }
                if(!Utils.isEmpty(fields["viewType"])){
                    cOptionViewType = fields["viewType"];
                }
                // if(!Utils.isEmpty(fields["cOptionCustomButton"]) && fields["cOptionCustomButton"] == 'true'){
                //     cOptionCustomButton = true;
                // }


           }
           else if (self.isChargeTypeRoundUp(chargeType)){
                // RoundUp Charge
                // if charge type round up then check only following options

                // Update the default value of Name and Description
                name = Default_Round_Up_Name;
                description = Default_Round_Up_Desc;

                if(!Utils.isEmpty(fields["cOptionName"])){
                    cOptionName = fields["cOptionName"];
                }

                if(!Utils.isEmpty(fields["cOptionDescription"])){
                    cOptionDescription = fields["cOptionDescription"];
                }

                if(!Utils.isEmpty(fields["cOptionInfoLink"])){
                    cOptionInfoLink = fields["cOptionInfoLink"];
                }
                if(!Utils.isEmpty(fields["cOptionLogoUrl"])){
                    cOptionLogoUrl = fields["cOptionLogoUrl"];
                }

           }

            let chargeDetail = this.state.chargeDetail;
            // Check the charge is updating or adding new charge
            // Check the orderType is same of changed
            // If order type is same then update the charge with same chargeId
            // If order is updated then delete the previous charge with chargeId
            // And update charge as a new charge according to selected latest order type


           // let newOrderType = fields.orderType;
           // let previousOrderType = chargeDetail.orderType;


           let chargeId = '';

            // Update the existing charge based on the charge id
            if (chargeDetail && !Utils.isEmptyObj(chargeDetail)) {

                // set the existing chargeId
                chargeId = chargeDetail.chargeId;
            }
            else {
                // generate the new chargeId
                chargeId = uuidv4();
            }

            let orderTypes = this.state.orderTypes;

            let paramsObject = {
                "chargeId"         : chargeId,
                "name"             : name.trim(),
                "orderTypes"       : orderTypes,
                "tag"              : tag.trim(),
                "desc"             : description,
                "type"             : chargeShortName,
                "active"           : status,
                "taxable"          : taxable
            };

            //  get the charges options JSON
            chargeOptions = self.getChargeOptionsJson();

            if (self.isChargeTypeFixed(chargeType)){
                // if charge type fixed then check only following options

                paramsObject["typeDetails"] = {
                    "values":chargeOptions
                }
            }
            else if (self.isChargeTypeOptional(chargeType)){
                // if charge type optional then check only following options


                paramsObject["typeDetails"] = {
                    "name": cOptionName,
                    "desc": cOptionDescription,
                    "infoLink": cOptionInfoLink,
                    "logoURL": cOptionLogoUrl,
                    "viewType":cOptionViewType,
                    "values": chargeOptions
                }

                // check the default Index is set or not
                if (Number.isInteger(this.state.defaultIdx)){
                   let defaultIndex = this.state.defaultIdx;
                    paramsObject["typeDetails"]["defaultIdx"] = defaultIndex
                }

            }
            else if (self.isChargeTypeRoundUp(chargeType)){
                // if charge type round up then check only following options
                paramsObject["typeDetails"] = {
                    "name": cOptionName,
                    "desc": cOptionDescription,
                    "infoLink": cOptionInfoLink,
                    "logoURL": cOptionLogoUrl,
                    "values": chargeOptions
                }
            }

            // save the charge data
            this.saveChargeDataToDatabase(paramsObject);
        }

    }

    saveChargeDataToDatabase(params){

        let self = this;
        let fields = self.state.fields;

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;

        // let chargeConfigObject = activeLocation.chargeConfig;
        let chargeConfigObject = CustomChargeStore.getCustomCharges();

        let chargeDetail = this.state.chargeDetail;
        let orderType = fields.orderType;

        // Update the existing charge based on the charge id
        if (chargeDetail && !Utils.isEmptyObj(chargeDetail)) {

            let chargeId = chargeDetail.chargeId;

                // find the charge based on the id
                let chargeIndex = chargeConfigObject.findIndex(function(charge){ return charge.chargeId == chargeId});
                // console.log(chargeIndex);
                // if charge exist then update with latest params
                if (chargeIndex != -1){

                    // update the same object
                    chargeConfigObject[chargeIndex] = params;

                }
                else {
                    // if chargeId is not exist then show the error message

                    let errors = {};
                    errors["errors"] = "ChargeId does not exist. Please contact to support team.";

                    self.setState({
                        errors: errors,
                        isLoaded : true
                    });
                    return;
                }

        } else {

            // If chargeConfigObject is not configured then set the empty array object
            if (chargeConfigObject == undefined || chargeConfigObject == null){
                chargeConfigObject = [];
            }

            // push the new params object
            chargeConfigObject.push(params);

        }

        let paramsObject = {
            "objectId"         : locId,
            "chargeConfig"     : chargeConfigObject
        };

        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    self.setState({
                        isLoaded : true
                    });

                    // Callback function after updating the charges
                    self.props.callBackAfterUpdate();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded : true });
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }

    addChargeOptionsAction(chargeOptionsArray, defaultIdx){

        if (defaultIdx == undefined || defaultIdx == null){
            defaultIdx = '';
        }

        let self = this;
        self.setState({
            chargeOptions : chargeOptionsArray,
            defaultIdx:defaultIdx
        });
    }

    isChargeTypeFixed(chargeType){
        if (chargeType == FIXED_CHARGE){
            return true;
        }
        else {
            return false;
        }
    }
    isChargeTypeOptional(chargeType){
        if (chargeType == OPTIONAL_CHARGE){
            return true;
        }
        else {
            return false;
        }
    }
    isChargeTypeRoundUp(chargeType){
        if (chargeType == ROUND_UP_CHARGE){
            return true;
        }
        else {
            return false;
        }
    }

    render() {

        let fields = this.state.fields;

        let orderTypesArray = this.state.orderTypes ? this.state.orderTypes : [];


        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}

                        <div className="border-class marginTop">
                            <h3 id="translations" className="page-header">Add Charge</h3>
                            {
                                this.state.errors["errors"] ? (
                                    <div className="alert alert-danger text-center" role="alert">
                                        <span className="form-text">{this.state.errors["errors"]}</span>
                                    </div>) : null

                            }
                            <form name="addChargeForm" className="addChargeForm" onSubmit= {this.addChargeFormSubmit.bind(this)}>

                                <div className="row form-group">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputPassword1">Status</label>
                                            <div onChange={this.handleChange.bind(this, "status")}>
                                                <label className="radio-inline">
                                                    <input type="radio" name="status" id="status1"
                                                           value="inactive"
                                                           checked={this.state.fields["status"] == 'inactive'}
                                                           onChange={()=>{}}/> Inactive
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="status" id="status2"
                                                           value="active"
                                                           checked={this.state.fields["status"] == 'active'}
                                                           onChange={()=>{}}/> Active
                                                </label>
                                            </div>
                                            <span style={{color: "red"}}
                                                  className="form-text">{this.state.errors["status"]}</span>
                                        </div>
                                    </div>
                                </div>

                                {
                                    !this.isChargeTypeRoundUp(this.state.fields["chargeType"]) ? (

                                        <div className="row form-group">

                                            <div className="row col-lg-12">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label htmlFor="labelName">Charge Name</label>
                                                        <input type="text" className="form-control" id="name" ref="name"
                                                               aria-describedby="name" placeholder="Enter Charge Name" maxLength={30} onChange={this.handleChange.bind(this, "name")} value={this.state.fields.name || ''}/>
                                                        <small style={{color: "gray", fontSize:"12px"}}>Shown as Line Item Charge</small><br/>
                                                        <span style={{color: "red"}} className="form-text">{this.state.errors["name"]}
                            </span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label htmlFor="exampleInputDescription">Charge Description</label>
                                                        <textarea className="form-control" name="description" id="description" ref="description" rows="1"  placeholder="Enter Charge Description" onChange={this.handleChange.bind(this, "description")} value={this.state.fields.description || ''}></textarea>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                    ) : null

                                }

                                <div className="row form-group">
                                    <div className="row col-lg-12">
                                    <div className="col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="labelName">Charge Tag</label>
                                        <input type="text" className="form-control"
                                               id="tag" ref="tag"
                                               aria-describedby="tag"
                                               placeholder="Enter Charge Tag"
                                               onChange={this.handleChange.bind(this, "tag")}
                                               value={this.state.fields.tag || ''}/>
                                        <span style={{color: "red"}}
                                              className="form-text">{this.state.errors["tag"]}
                            </span>
                                    </div>
                                </div>
                                    </div>
                                </div>

                                <div className="row form-group">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputPassword1">Choose the Charge Type</label>
                                            <div
                                                onChange={this.handleChange.bind(this, "chargeType")}>
                                                <label className="radio-inline">
                                                    <input type="radio" name="chargeType"
                                                           id="chargeType1"
                                                           value="fixed"
                                                           checked={this.isChargeTypeFixed(this.state.fields["chargeType"])}
                                                           onChange={()=>{}}/> Fixed
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="chargeType"
                                                           id="chargeType2"
                                                           value="optional"
                                                           checked={this.isChargeTypeOptional(this.state.fields["chargeType"])}
                                                           onChange={()=>{}}/> Optional
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="chargeType"
                                                           id="chargeType3"
                                                           value="roundUp"
                                                           checked={this.isChargeTypeRoundUp(this.state.fields["chargeType"])}
                                                           onChange={()=>{}}/> Round
                                                    Up
                                                </label>
                                            </div>
                                            {
                                                this.state.chargeTypeMsg ? (
                                                    <span style={{color: "gray", marginTop:"10px"}}
                                                          className="form-text">{this.state.chargeTypeMsg}</span>
                                                ) : null

                                            }
                                            <br/>
                                            {
                                                this.state.errors["chargeType"] ? (
                                                    <span style={{color: "red"}}
                                                          className="form-text">{this.state.errors["chargeType"]}</span>
                                                ) : null

                                            }


                                        </div>
                                    </div>
                                </div>

                                {
                                    this.state.showTaxableField ? (
                                        <div className="row form-group">
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="exampleInputPassword1">Taxable </label><small> (If you want to apply tax on charge.)</small>
                                                    <div
                                                        onChange={this.handleChange.bind(this, "taxable")}>
                                                        <label className="radio-inline">
                                                            <input type="radio" name="taxable"
                                                                   id="taxable1"
                                                                   value="false"
                                                                   checked={this.state.fields["taxable"] == 'false'}
                                                                   onChange={()=>{}}/> False
                                                        </label>
                                                        <label className="radio-inline">
                                                            <input type="radio" name="taxable"
                                                                   id="taxable2"
                                                                   value="true"
                                                                   checked={this.state.fields["taxable"] == 'true'}
                                                                   onChange={()=>{}}/> True
                                                        </label>
                                                    </div>
                                                    <span style={{color: "red"}}
                                                          className="form-text">{this.state.errors["taxable"]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null
                                }

                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Choose the Order Type</label>
                                                    <div>
                                                        <label className="checkbox-inline">
                                                            <input type="checkbox" name="orderType"
                                                                   id="orderType1"
                                                                   value="Delivery"
                                                                   onChange={this.handleChange.bind(this, "orderType")}
                                                                   checked={orderTypesArray.includes("Delivery")}
                                                            /> Delivery
                                                        </label>
                                                        <label className="checkbox-inline">
                                                            <input type="checkbox" name="orderType"
                                                                   id="orderType2"
                                                                   value="PickUp"
                                                                   onChange={this.handleChange.bind(this, "orderType")}
                                                                   checked={orderTypesArray.includes("PickUp")}
                                                            /> PickUp
                                                        </label>
                                                        <label className="checkbox-inline">
                                                            <input type="checkbox" name="orderType"
                                                                   id="orderType3"
                                                                   value="CurbsidePickUp"
                                                                   onChange={this.handleChange.bind(this, "orderType")}
                                                                   checked={orderTypesArray.includes("CurbsidePickUp")}
                                                            /> Curbside
                                                            PickUp
                                                        </label>
                                                        <label className="checkbox-inline">
                                                            <input type="checkbox" name="orderType"
                                                                   id="orderType4"
                                                                   value="DineIn"
                                                                   onChange={this.handleChange.bind(this, "orderType")}
                                                                   checked={orderTypesArray.includes("DineIn")}
                                                            /> DineIn
                                                        </label>
                                                    </div>
                                                    <span style={{color: "red"}}
                                                          className="form-text">{this.state.errors["orderType"]}</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                {
                                    this.isChargeTypeFixed(this.state.fields["chargeType"]) ? (

                                        <div className="row form-group">
                                        <div className="row col-lg-12">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="labelName">Percentage
                                                        (%)</label>
                                                    <input type="tel"
                                                           pattern="^-?[0-9]\d*\.?\d*$"
                                                           className="form-control"
                                                           id="percentageFee" ref="percentageFee"
                                                           aria-describedby="percentageFee"
                                                           placeholder="Enter charge percentage"
                                                           onChange={this.handleChange.bind(this, "percentageFee")}
                                                           value={this.state.fields.percentageFee || null}/>
                                                    {/*<small> (Enter 0 for not applying percentage.)</small>*/}
                                                    <span style={{color: "red"}}
                                                          className="form-text">{this.state.errors["percentageFee"]}
                                            </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="exampleInputDescription">Fixed Amount ($)</label>
                                                    <input type="tel"
                                                           pattern="^-?[0-9]\d*\.?\d*$"
                                                           className="form-control"
                                                           id="fixedFee" ref="fixedFee"
                                                           aria-describedby="fixedFee"
                                                           placeholder="Enter fixed charge amount"
                                                           onChange={this.handleChange.bind(this, "fixedFee")}
                                                           value={this.state.fields.fixedFee || null}/>
                                                    {/*<small> (Enter 0 for not applying fixed amount.)</small>*/}
                                                    <span style={{color: "red"}}
                                                          className="form-text">{this.state.errors["fixedFee"]}
                                            </span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>

                                    ) : null
                                }


                                {
                                    this.state.showChargeOptionsView ? (
                                        <div className="form-group">
                                            <div className="col-lg-12">
                                                <h4 id="translations" className="page-header"><strong>Add {this.state.labelOptions} Details</strong></h4>

                                            </div>
                                            <div className="col-md-12">
                                                {/*<div className="row">*/}
                                                <div className="row form-group">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label htmlFor="labelName">{this.state.labelOptions} Name</label>
                                                            <input type="text"
                                                                   className="form-control"
                                                                   id="cOptionName"
                                                                   name="cOptionName"
                                                                   ref="cOptionName"
                                                                   aria-describedby="name"
                                                                   placeholder={"Enter "+this.state.labelOptions+" Name"}
                                                                   onChange={this.handleChange.bind(this, "cOptionName")}
                                                                   value={this.state.fields.cOptionName || ''}/>
                                                            <span style={{color: "red"}}
                                                                  className="form-text">{this.state.errors["cOptionName"]}
                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label
                                                                htmlFor="exampleInputDescription">Short Description</label>
                                                            <textarea className="form-control"
                                                                      name="cOptionDescription"
                                                                      id="cOptionDescription"
                                                                      ref="description" rows="1"
                                                                      placeholder="Short Description"
                                                                      onChange={this.handleChange.bind(this, "cOptionDescription")}
                                                                      value={this.state.fields.cOptionDescription || ''}></textarea>
                                                            <small> (One line description explaining the {this.state.labelOptions} cause.)</small>
                                                            <br/>
                                                            <span style={{color: "red"}}
                                                                  className="form-text">{this.state.errors["cOptionDescription"]}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label htmlFor="labelName">{this.state.labelOptions} Website </label>
                                                            <input type="text"
                                                                   className="form-control"
                                                                   id="cOptionInfoLink"
                                                                   ref="cOptionInfoLink"
                                                                   aria-describedby="name"
                                                                   placeholder={"Enter "+this.state.labelOptions+" Website Link"}
                                                                   onChange={this.handleChange.bind(this, "cOptionInfoLink")}
                                                                   value={this.state.fields.cOptionInfoLink || ''}/>
                                                            <small> (Add a link so user can find details about the {this.state.labelOptions}.)</small><br/>
                                                            <span style={{color: "red"}}
                                                                  className="form-text">{this.state.errors["cOptionInfoLink"]}
                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label htmlFor="labelName">{this.state.labelOptions} Logo URL</label>
                                                            <input type="text"
                                                                   className="form-control"
                                                                   id="cOptionLogoUrl"
                                                                   ref="cOptionLogoUrl"
                                                                   aria-describedby="name"
                                                                   placeholder={"Enter "+this.state.labelOptions+" Logo URL"}
                                                                   onChange={this.handleChange.bind(this, "cOptionLogoUrl")}
                                                                   value={this.state.fields.cOptionLogoUrl || ''}/>
                                                            <span style={{color: "red"}}
                                                                  className="form-text">{this.state.errors["cOptionLogoUrl"]}
                            </span>
                                                        </div>
                                                    </div>

                                                    {
                                                        this.isChargeTypeOptional(this.state.fields["chargeType"]) ? (
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputPassword1">How would you like to show options in cart screen?</label>
                                                                    <div>
                                                                        <label className="checkbox-inline">
                                                                            <input type="checkbox" name="orderType"
                                                                                   id="viewType1"
                                                                                   value="Row"
                                                                                   onChange={this.handleChange.bind(this, "viewType")}
                                                                                   checked={this.state.fields["viewType"] == "Row"}
                                                                            /> Row
                                                                        </label>
                                                                        <label className="checkbox-inline">
                                                                            <input type="checkbox" name="orderType"
                                                                                   id="viewType2"
                                                                                   value="Column"
                                                                                   onChange={this.handleChange.bind(this, "viewType")}
                                                                                   checked={this.state.fields["viewType"] == "Column"}
                                                                            /> Column
                                                                        </label>

                                                                    </div>
                                                                    <span style={{color: "red"}}
                                                                          className="form-text">{this.state.errors["orderType"]}</span>
                                                                </div>
                                                            </div>
                                                        )  : null
                                                    }

                                                </div>
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                    ) : null
                                }

                                {
                                    this.state.showChargeOptionsValueView ? (
                                        <div className="form-group">
                                            <div className="col-lg-12">
                                                <h4 id="translations" className="page-header">Add Charge Options <small>(You can configure multiple options)</small></h4>
                                            </div>
                                            <div className="col-md-12">
                                                <AddChargeOptions
                                                    callBackAddOptions={this.addChargeOptionsAction}
                                                    chargeOptions={this.state.chargeOptions}
                                                    defaultIdx={this.state.defaultIdx}
                                                    selectedChargeType={this.state.selectedChargeType}
                                                />
                                            </div>
                                        </div>
                                    ) : null
                                }
                                <div className="form-group">
                                    <button type="submit" className="btn btn-export">Save</button>
                                    <button type="submit" className="btn btn-default back-button" onClick={_ => this.props.callBackParent()} >Back</button>

                                </div>
                            </form>
                        </div>


            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/custom-charges/add-charge.js